import { Container, Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

import { CustomModal } from '../../shared';
import { styles } from './styles';

const ResetConsumerGroup = (props) => {
  const { openDialog, onCloseDialog, onReset, classes } = props;

  return (
    <Grid container spacing={2}>
      <CustomModal
        className={classes.root}
        dialogTitle="Reset Consumer Group"
        openDialog={openDialog}
        onCloseDialog={onCloseDialog}
        arrayOfButtons={[
          {
            label: 'Cancel',
            color: 'default',
            enabled: true,
            action: () => {
              onCloseDialog();
            }
          },
          {
            label: 'Yes',
            variant: 'contained',
            color: 'primary',
            enabled: true,
            action: () => {
              onReset();
              onCloseDialog();
            }
          }
        ]}>
        <Grid key="topicName" item xs={12} className={classes.row}>
          <Container>
            <Typography paragraph>
              Resetting the offset for this consumer group will show the messages from the beginning of the topic. Are you sure you want to reset it?
            </Typography>
          </Container>
        </Grid>
      </CustomModal>
    </Grid>
  );
};

export const ResetConsumerGroupModal = withStyles(styles)(ResetConsumerGroup);
